/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AxiosPlugin from "./plugins/axios";
import RecaptchaPlugin from "./plugins/recaptcha";
import VueGtag from "vue-gtag";
import "@/assets/css/base.scss";

console.log("Site Path: " + process.env.VUE_APP_SITE_URL);

Vue.config.productionTip = false;
Vue.use(AxiosPlugin);
Vue.use(
  VueGtag,
  {
    config: {
      id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
      // params: {
      //   send_page_view: false
      // }
    }
  },
  router
);

Vue.use(RecaptchaPlugin, { siteKey: process.env.VUE_APP_RECAPTCHA });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
